import { HTTPClient, propsToDate, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { DateHelper } from '@abaco/web-components/src/components/DateUtils';
import { ActionOut, Action, ActionFormDataOut } from '../models/Action';
import axios, { CancelTokenSource } from "axios";
import { FieldRegistry, FieldRegistryType } from '../models/FieldRegistry';

export default class ActionApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    public async getFieldRegistryTypes(): Promise<FieldRegistryType[]> {
        const res = await this.http.get(`/treatment-register-api/api/v1/brgTypes/list`, {
            params: {
                offset: 0,
                count: 300
            }
        })
        return res.data.records;
    }

    public async getFieldRegistries(pk_cuaa: number, typeId: number): Promise<PagedResults<FieldRegistry>> {
        const res = await this.http.get(`/treatment-register-api/api/v1/brgHeaders/${pk_cuaa}/list/filtered?limit=1000`, {
            params: {
                offset: 0,
                count: 300,
                typeId: typeId,
            }
        })
        return res.data;
    }
    public async getAllFieldRegistries(pk_cuaa: number, typeIds: number[]): Promise<FieldRegistry[]> {
        const els: FieldRegistry[] = [];
        await Promise.all(typeIds.map(async (e) => {
            const res = await this.getFieldRegistries(pk_cuaa, e);
            res.records.forEach(f => {
                els.push(f);
            })
        }));
        return els;
    }

    public async getExecutionFieldRegistries(pk_cuaa: number, campaign: number, execution_id: number): Promise<FieldRegistry[]> {
        const res = await this.http.get(`/treatment-register-api/api/v1/brg/${pk_cuaa}/${campaign}/getBrgIdList/${execution_id}`, {
            params: {
                offset: 0,
                count: 300
            }
        })
        return res.data;
    }

    public async exportActionToFieldRegistry(pk_cuaa: number, campaign: number, executionId: number, fieldRegistryId: number | null, fieldRegistryTypeId: number | null): Promise<boolean> {
        let url = `/treatment-register-api/api/v1/brg/${pk_cuaa}/${campaign}/importFrmActivity/${executionId}`;
        if(fieldRegistryId){
            url = url + `?brg_header_id=${fieldRegistryId}`;
        }
        if(fieldRegistryTypeId){
            url = url + `?brg_type_id=${fieldRegistryTypeId}`;
        }
        const res = await this.http.put(url);
        return res.data ? true : false;
    }

}
